// stores/permissionStore.ts
import { defineStore } from "pinia";
import userService from "@/utils/userService";
import lodash from "lodash";
import { normalizeAuthorizedHospitals } from "@/utils/institutionAccess";

let freshlyLoadedUserId = "";

export const usePermissionStore = defineStore("permission", {
  state: () => ({
    permissions: [] as any[],
    hospitals: [] as any[],
    superAdmin: false,
  }),

  getters: {
    hasPermission: (state) => {
      return (code: any) => {
        const item = state.permissions.find((item) => item.code === code && item.checked);
        return !!item;
      };
    },
    permissionTopNav: (state) => {
      return () => {
        return state.permissions.filter((item) => item.type === 1 && item.checked);
      };
    },
  },

  actions: {
    resetAuthorization() {
      this.permissions = [];
      this.hospitals = [];
      this.superAdmin = false;
      freshlyLoadedUserId = "";
    },
    hasFreshPermissions(userId: string | number) {
      return freshlyLoadedUserId === String(userId);
    },
    async fetchPermissions(userId: string) {
      const flattenTree: any = (nodes: any) => {
        return lodash.flatMapDeep(nodes, (node) => {
          if (node.children) {
            return [lodash.omit(node, "children"), ...flattenTree(node.children)];
          } else {
            return node;
          }
        });
      };

      this.permissions = [];
      this.hospitals = [];
      freshlyLoadedUserId = "";

      try {
        const response = await userService.getUserPermissions(userId);
        const permissions = flattenTree(response.data?.permission?.children || []);
        this.permissions = permissions;
        this.hospitals = normalizeAuthorizedHospitals(response.data?.hospitals);
        freshlyLoadedUserId = String(userId);
        return "ok";
      } catch (error) {
        console.error("Failed to fetch permissions:", error);
        throw error;
      }
    },
    setSuperAdmin(superAdmin: boolean) {
      this.superAdmin = superAdmin;
    },
  },

  persist: true, // 直接设置 persist 为 true 来启用持久化
});
